export default {
  create_title: 'Nuovo account Partner API',
  edit_title: 'Modifica account',
  form: {
    name: 'Nome account',
    name_placeholder: 'es. integrazione POS Acme',
    contact_email: 'Email di contatto',
    scope: 'Accesso ai ristoranti',
    companies: 'Ristoranti',
    scope_selected: 'Ristoranti selezionati',
    scope_all: 'Tutti i ristoranti',
    scope_all_help:
      'Le chiavi su questo account raggiungono ogni ristorante della tua organizzazione, compresi quelli registrati in seguito.',
    companies_help: 'Le chiavi emesse su questo account possono leggere e scrivere solo questi ristoranti.',
    is_active: 'Attivo',
    is_active_help: 'Gli account inattivi vengono rifiutati in fase di autenticazione.',
  },
  buttons: {
    cancel: 'Annulla',
    save: 'Salva',
    create: 'Crea',
  },
  toasts: {
    created: 'Account Partner API creato.',
    updated: 'Account aggiornato.',
    error: "Impossibile salvare l'account.",
  },
};
